<div class="section-divider d-none d-md-flex align-items-center gap-3 my-3">
  <div class="flex-grow-1 border-top"></div>
  <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">🗑️ {{ 'MUELLABFUHR' | translate }}</span>
  <div class="flex-grow-1 border-top"></div>
</div>

<div *ngIf="nextPickupsByType.length > 0">
  <div class="row g-2">
    <div class="col-6 col-sm-4 col-lg-3 col-xl-2" *ngFor="let p of nextPickupsByType">
      <ng-template #wastePopup>
        <div class="d-flex align-items-center gap-2 mb-2">
          <img [src]="p.icon" alt="" width="24" height="24" style="object-fit:contain;">
          <span class="fw-semibold small">{{ 'MUELL_NAME_' + p.type | translate }}</span>
        </div>
        <div *ngFor="let d of allDatesForType(p.type)"
             class="d-flex justify-content-between gap-3 py-1 border-bottom"
             style="font-size:.85rem;">
          <span [class.text-danger]="daysUntil(d) === 0"
                [class.text-warning]="daysUntil(d) === 1 || daysUntil(d) === 2"
                [class.fw-bold]="daysUntil(d) <= 2">{{ fmtWasteDate(d) }}</span>
          <span [class.text-success]="daysUntil(d) > 2"
                [class.text-warning]="daysUntil(d) === 1 || daysUntil(d) === 2"
                [class.text-danger]="daysUntil(d) === 0">
            {{ wasteRelative(d) }}
          </span>
        </div>
      </ng-template>
      <app-popup-card
          [cardClass]="'h-100' + (daysUntil(p.date) === 0 ? ' border-danger' : (daysUntil(p.date) === 1 || daysUntil(p.date) === 2) ? ' border-warning' : '')"
          popupMaxWidth="320px"
          [popupTpl]="wastePopup">
        <ng-template #body>
          <div class="card-body d-flex align-items-center gap-2 p-2 p-sm-3">
            <img [src]="p.icon" alt="" width="40" height="40" class="flex-shrink-0"
                 style="object-fit:contain;pointer-events:none;">
            <div class="min-w-0">
              <div class="text-muted small text-truncate">{{ 'MUELL_NAME_' + p.type | translate }}</div>
              <div class="fw-bold small text-truncate"
                   [class.text-danger]="daysUntil(p.date) === 0"
                   [class.text-warning]="daysUntil(p.date) === 1 || daysUntil(p.date) === 2">
                {{ fmtWasteDate(p.date) }}
              </div>
              <div class="text-truncate d-none d-xl-block" style="font-size:.7rem;"
                   [class.text-success]="daysUntil(p.date) > 2"
                   [class.text-warning]="daysUntil(p.date) === 1 || daysUntil(p.date) === 2"
                   [class.text-danger]="daysUntil(p.date) === 0">
                {{ wasteRelative(p.date) }}
              </div>
            </div>
          </div>
          <div class="card-footer d-xl-none text-center p-1" style="font-size:.62rem;"
               [class.text-success]="daysUntil(p.date) > 2"
               [class.text-warning]="daysUntil(p.date) === 1 || daysUntil(p.date) === 2"
               [class.text-danger]="daysUntil(p.date) === 0">
            {{ wasteRelative(p.date) }}
          </div>
        </ng-template>
      </app-popup-card>
    </div>
  </div>
</div>
<div *ngIf="nextPickupsByType.length === 0 && loading" class="row g-2">
  <div class="col-6 col-sm-4 col-lg-3 col-xl-2" *ngFor="let _ of [0,1,2,3]">
    <div class="card h-100">
      <div class="card-body d-flex align-items-center gap-2 p-2 p-sm-3">
        <app-skeleton width="40px" height="40px" radius="6px" [darkMode]="darkMode" style="flex-shrink:0;"></app-skeleton>
        <div style="flex:1;min-width:0;">
          <app-skeleton width="80%" height=".75rem" radius="4px" [darkMode]="darkMode" style="display:block;margin-bottom:6px;"></app-skeleton>
          <app-skeleton width="60%" height=".85rem" radius="4px" [darkMode]="darkMode" style="display:block;"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="nextPickupsByType.length === 0 && !loading" class="text-muted small text-center py-2">{{ 'KEINE_DATEN' | translate }}</div>
